var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"7"}},[_c('project-statistics-card')],1),_c('v-col',{attrs:{"cols":"12","md":"5"}},[(_vm.$canACL('view', 'organizations', _vm.projectsStore.GET_PROJECT?.organization))?_c('organization-statistics-card'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }